<template>
    <div class="max-w-80 w-full sm:w-80 sm:max-w-none md:w-56">
        <div
            data-testid="lettr-promo-template-card"
            class="max-w-80 relative flex h-[364px] w-full flex-col rounded-[6px] border border-red-100 bg-white shadow-card sm:w-80 sm:max-w-none md:w-56"
        >
            <button
                type="button"
                aria-label="Dismiss"
                data-testid="lettr-promo-template-card-dismiss"
                class="absolute right-2.5 top-2.5 rounded-[4px] p-1 text-gray-400 transition duration-100 ease-in-out hover:bg-gray-100 hover:text-gray-600"
                @click="dismiss('lettr_template_card')"
            >
                <XMarkIcon class="h-4 w-4" />
            </button>

            <div
                class="flex flex-1 flex-col items-center justify-center rounded-t-[6px] bg-red-50 px-6 text-center"
            >
                <img :src="LETTR_LOGO" class="h-12 w-12" alt="" />

                <p class="mt-4 text-base font-medium text-gray-700">
                    Keep your templates editable
                </p>

                <p class="mt-2 text-sm leading-normal text-gray-500">
                    Lettr is an email platform with the Topol editor built in,
                    so your templates land ready to edit and send.
                </p>
            </div>

            <div class="border-t border-gray-200 p-[18px] text-center">
                <AtomicButton
                    class="w-full"
                    color="yellow"
                    size="md"
                    @click="connect('lettr_template_card')"
                >
                    Connect Lettr
                </AtomicButton>

                <!-- A real anchor, so it can be opened in a new tab or copied
                     like any other link; the same label as the v2 banner uses
                     for the same destination. -->
                <a
                    :href="lettrHomeUrl('lettr_template_card')"
                    target="_blank"
                    rel="noopener"
                    class="mt-3 inline-block text-sm font-medium text-topol-blue-500 hover:text-topol-blue-600"
                    @click="trackLearnMore('lettr_template_card')"
                >
                    See how it works
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

import { XMarkIcon } from '@heroicons/vue/24/outline';

import AtomicButton from '@/components/Atomic/Buttons/AtomicButton.vue';
import useLettrPromo, { LETTR_LOGO } from '@/composables/useLettrPromo';
import { lettrHomeUrl } from '@/utils/lettrUrls';

const { trackImpression, trackLearnMore, dismiss, connect } = useLettrPromo();

onMounted(() => {
    trackImpression('lettr_template_card');
});
</script>
